import { themeLogoLimits } from "../../constants";

export const createThemeFormData = (formList, existingTheme) => {
  const formData = new FormData();

  formData.append("brandID", existingTheme.brandID);
  formData.append("fontColor", formList.fontColor);
  formData.append("fontStyle", formList.fontStyle);
  formData.append("id", existingTheme.id);
  formData.append("logoFile", formList.logoFile);
  formData.append("mainThemeColor", formList.mainThemeColor);
  formData.append("progressBarColor", formList.progressBarColor);
  formData.append("surveyStyle", formList.surveyStyle);
  formData.append("starColor", formList.starColor);

  return formData;
};

export const isThemeLogoLargeEnough = (width, height) =>
  width >= themeLogoLimits.MIN_WIDTH_PX &&
  height >= themeLogoLimits.MIN_HEIGHT_PX;
